import dayjs from "dayjs"
import { useEffect, useState } from "react"
import { Button, Col } from "react-bootstrap"
import { toast } from "react-toastify"
import LoadingModal from "../../../components/loadingModal"
import { ApiEndpoints, reqGetNew, reqPostNew } from "../../../config/apiClient"
import { getCookie } from "../../../config/cookies"
import css from '../all/styles.module.css'
import { DocumentoStatus, ListaUsuarioAssinaturas } from "../pendentes/PainelDocumentosPendentes"

function DocumentosLixeiraPage() { 
    const [loading, setLoading] = useState<boolean>(false)
    const [loadingHandle, setLoadingHandle] = useState<boolean>(false)
    const [documentos, setDocumentos] = useState<any[]>([])
    
    useEffect(() => {
        document.title = "Documentos Lixeira | OB PORTUS APP"
        getDocumentosLixeira()
        // eslint-disable-next-line
    }, [])
    
    async function getDocumentosLixeira() { 
        setLoading(true)
        const api = await reqGetNew(ApiEndpoints.documentosDeletados)
        if (api.status === 200) { 
            let documentosAux = api.data
            for (let i in documentosAux) { 
                documentosAux[i]["selecionado"] = false
            }
            console.info(documentosAux)
            setDocumentos(documentosAux)
        }
        setLoading(false)
    }
    
    async function handleAtualizar() {
        getDocumentosLixeira()
    }
    
    async function handleDeletar() {
        if (!window.confirm(`Tem certeza que deseja continuar?`)) {
            return
        }
        
        setLoadingHandle(true)
        const selecionados:any[] = documentos.filter(reg => reg.selecionado === true)
        const id_usuario = Number(getCookie("id_user"))
        let documentos_nomes = ""
        let documentos_nomes_erros = ""
        console.info(selecionados)
        for (let doc of selecionados) { 
            
            const dados = {
                "id_documento": doc.id,
                "id_usuario": id_usuario,
            }
            const api = await reqPostNew(ApiEndpoints.documentoDeletarPermanentemente, dados)
            if (api.status === 200) {
                if (documentos_nomes === "") {
                    documentos_nomes = doc.nome
                } else { 
                    documentos_nomes += `, ${doc.nome}`
                }
            } else {
                if (documentos_nomes_erros === "") {
                    documentos_nomes_erros = doc.nome
                } else { 
                    documentos_nomes_erros += `, ${doc.nome}`
                }
            }
            
        }
        setLoadingHandle(false)
        if (documentos_nomes !== "") { 
            toast.success(`Deletados: ${documentos_nomes}`, {
                containerId: 1,
                position: 'top-center',
                theme: 'dark',
                autoClose: 20000,
            })
            await getDocumentosLixeira()
        }
        if (documentos_nomes_erros !== "") { 
            toast.error(`Erros: ${documentos_nomes_erros}`, {
                containerId: 1,
                position: 'top-center',
                theme: 'dark',
                autoClose: 20000,
            })
        }
    }
    
    async function handleRestaurar() { 
        if (!window.confirm(`Tem certeza que deseja continuar?`)) {
            return
        }
        
        setLoadingHandle(true)
        const selecionados:any[] = documentos.filter(reg => reg.selecionado === true)
        const id_usuario = Number(getCookie("id_user"))
        let documentos_nomes = ""
        let documentos_nomes_erros = ""
        console.info(selecionados)
        for (let doc of selecionados) { 
            
            const dados = {
                "id_documento": doc.id,
                "id_usuario": id_usuario,
            }
            const api = await reqPostNew(ApiEndpoints.documentoDeletarRestaurar, dados)
            if (api.status === 200) {
                if (documentos_nomes === "") {
                    documentos_nomes = doc.nome
                } else { 
                    documentos_nomes += `, ${doc.nome}`
                }
            } else {
                if (documentos_nomes_erros === "") {
                    documentos_nomes_erros = doc.nome
                } else { 
                    documentos_nomes_erros += `, ${doc.nome}`
                }
            }
            
        }
        setLoadingHandle(false)
        if (documentos_nomes !== "") { 
            toast.success(`Restaurados: ${documentos_nomes}`, {
                containerId: 1,
                position: 'top-center',
                theme: 'dark',
                autoClose: 20000,
            })
            await getDocumentosLixeira()
        }
        if (documentos_nomes_erros !== "") { 
            toast.error(`Erros: ${documentos_nomes_erros}`, {
                containerId: 1,
                position: 'top-center',
                theme: 'dark',
                autoClose: 20000,
            })
        }
    }
    
    function selecionarDocumento(codigo:string, ativo: boolean) { 
        const documentosAux = documentos
        for (let idx in documentosAux) { 
            if (documentosAux[idx]["codigo"] === codigo) { 
                documentosAux[idx]["selecionado"] = ativo
            }
        }
        setDocumentos(documentosAux)
    }
    
    function handleClickDocumento(mouseClick: number, codigo: string) {
        const link = `/documento?id=${codigo}`
        if (mouseClick === 0) {
            window.location.assign(link)
        }
        if (mouseClick === 1) {
            window.open(link)
        }
    }
    
    const cssDocumentoIcon:React.CSSProperties = {
        display: "flex",
        alignItems: "center",
        marginBottom: "10px"
    }
    
    return (
        <div id="main">
            <LoadingModal show={loading} handleClose={() => { }} />
            <LoadingModal show={loadingHandle} handleClose={() => { }} />
            <div className="div-row-space-between">
                <h1 id="titleMain">Documentos Lixeira</h1>
            </div>
            
            <div className="div_navdocs">
                <div id={css.div_controls}>
                    <div>
                        <Button className={css.btn_acoes} variant="outline-secondary" onClick={() => { handleAtualizar() }} style={{ display: "inline-flex", alignItems: "center", borderRadius: "20px", justifyContent: "center", padding: "0px", width: "38px", height: "38px" }} >
                            <span className="material-symbols-outlined" style={{ padding: "0px", margin: "0px" }}>
                                refresh
                            </span>
                        </Button>
                        <Button className={css.btn_acoes} variant="outline-secondary" onClick={() => { handleDeletar() }} >Excluir Permanentemente</Button>
                        <Button className={css.btn_acoes} variant="outline-secondary" onClick={() => { handleRestaurar() }} >Restaurar</Button>
                        <p style={{ fontWeight: "bold",display: "inline-flex", marginLeft: "10px" }}>Exclusão automática após 90 dias.</p>
                    </div>
                </div>
            </div>
            
            <div id={css.div_arquivos}>
                <div id={css.div_arquivos_border}>
                    <div>
                        {
                            !loading &&
                            documentos.map((documento, idx) => {
                                let data_assinado = <span></span>
                                if (documento.data_assinado !== null) {
                                    data_assinado = <span className={css.documento_data_finalizado}>Finalizado em {dayjs(documento.data_criacao).format("DD/MM/YYYY HH:mm")}</span>
                                }
                                let documento_local = <span></span>
                                if (String(documento.original_caminho).search("local") > 0) { 
                                    documento_local = <span className={css.documento_data_finalizado}>HOMOLOGAÇÃO DEV</span>
                                }
                                return (
                                    <div key={idx} className={css.div_documentos} onClick={(event) => {
                                        // console.log(event)
                                        const target:any = event.target
                                        if (target.localName === "input") {
                                            return
                                        }
                                        event.preventDefault()
                                        event.stopPropagation()
                                        handleClickDocumento(event.button, documento.codigo)
                                        window.location.href = `/documento?id=${documento.codigo}`
                                    }} onMouseUp={(event) => {
                                        // console.log(event)
                                        const target:any = event.target
                                        if (target.localName === "input") {
                                            return
                                        }
                                        event.preventDefault()
                                        event.stopPropagation()
                                        handleClickDocumento(event.button, documento.codigo)
                                    }} onMouseDown={(event) => { if (event.button === 1) { event.preventDefault(); event.stopPropagation() } }}>
                                        <div className="div-row">
                                            <Col className="col-5">
                                                <div style={cssDocumentoIcon}>
                                                    <input className={css.arquivo_checkbox} id={`check_pasta_${documento.id_pasta}`} type="checkbox" onChange={(event) => {
                                                        const target: any = event.target
                                                        selecionarDocumento(documento.codigo, target.checked)
                                                        // dispatch(selecionarDocumento({codigo: documento.codigo, ativo: target.checked}))
                                                    }} defaultChecked={documento.selecionado} />
                                                    <span className="material-symbols-outlined" style={{marginRight: "10px", color: "#0d6efd"}}>
                                                        draft
                                                    </span>
                                                    <p className={css.arquivo_name}>{documento.nome}</p>
                                                    {documento_local}
                                                </div>
                                                <p className={css.documento_criacao}>#{documento.id} Criado em {dayjs(documento.data_criacao).format("DD/MM/YYYY HH:mm")}{data_assinado}</p>
                                                { documento.id_usuario !== null && <p className={css.documento_nome_usuario}>Por {documento.id_usuario.nome}</p> }
                                                
                                            </Col>
                                            <Col className="col-4">
                                                <p>Assinaturas</p>
                                                <ListaUsuarioAssinaturas assinaturas={documento.signatarios} />
                                            </Col>
                                            <Col className="col-3" >
                                                <DocumentoStatus id_status={documento.id_status.id_status} status={documento.id_status.descricao} lixeira={1} />
                                                { 
                                                    documento.data_excluido !== null &&
                                                    <div>
                                                        <p style={{marginTop: "5px"}}>Excluído em {dayjs(documento.data_excluido).format("DD/MM/YYYY HH:mm")}</p>
                                                        { 
                                                            documento.id_usuario_excluido !== null &&
                                                            <p>Por {documento.id_usuario_excluido.nome}</p>
                                                        }
                                                    </div>
                                                }
                                            </Col>
                                        </div>
                                    </div>
                                )
                            })
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}

export default DocumentosLixeiraPage